import gsap from 'gsap'; // Ensure GSAP is imported
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function fadeIn (element , duration = 0.6 , delay = 0.5 , scale = false){
    if(!element) return;

    gsap.fromTo(
        element,
    {
        opacity : 0,
        scale : scale === true ? 0 : 1,
    },
    {
        opacity : 1 ,
        scale : scale === true ? 1 : 1,
        delay: delay,
        duration: duration,
        ease: "sine.inOut",
        scrollTrigger: {
            trigger: element,
            start: "top bottom", // when card is 80% from top of viewport
            toggleActions: "play none none reverse",
        },
        once : true,

        onComplete: () => {

        },
    }
    );
}


export function fadeBottom (element , duration = 0.6 , delay = 0.5){
        if(!element) return;

        gsap.fromTo(
            element,
        {
            y : 100 ,
            opacity : 0
        },
        {
            opacity : 1 ,
            y : 0 ,
            delay: delay,
            duration: duration,
            ease: "sine.inOut",
            scrollTrigger: {
                trigger: element,
                start: "top bottom", // when card is 80% from top of viewport
                toggleActions: "play none none reverse",
            },
            once : true,

            onComplete: () => {

            },
        }
        );
}

export function counterUp (elements , duration = 1.6 , delay = 0.2){
    elements.forEach((el, index) => {
        if(!el) return;

        const raw = el.textContent.trim();
        const match = raw.match(/^(\D*)([\d.,]*\d)(\D*)$/);
        if(!match) return;

        const [, prefix, numStr, suffix] = match;
        const grouped = numStr.includes(',');
        const decimals = numStr.includes('.') ? numStr.split('.').pop().length : 0;
        const target = parseFloat(numStr.replace(/,/g, ''));

        if(isNaN(target)) return;

        const counter = { value: 0 };

        gsap.to(counter, {
            value: target,
            delay: delay + index * 0.1,
            duration: duration,
            ease: "power2.out",
            scrollTrigger: {
                trigger: el,
                start: "top bottom",
                toggleActions: "play none none reverse",
            },
            once : true,

            onUpdate: () => {
                let formatted = decimals > 0 ? counter.value.toFixed(decimals) : Math.round(counter.value).toString();

                if(grouped){
                    const [intPart, decPart] = formatted.split('.');
                    formatted = Number(intPart).toLocaleString() + (decPart ? '.' + decPart : '');
                }

                el.textContent = prefix + formatted + suffix;
            },
        });
    });
}

export function animationCard (cards , duration = 0.6 , delay = 0.4 , trigger = null){
    cards.forEach((card, index) => {
        if(!card) return;

        gsap.fromTo(
            card,
        {
            opacity : 0,
        },
        {
            opacity : 1 ,
            delay: delay + index * 0.1,
            duration: duration,
            ease: "power3.inOut",
            scrollTrigger: {
                trigger: trigger || card,
                start: "top bottom", // when card is 80% from top of viewport
                toggleActions: "play none none reverse",
            },
            once : true,

            onComplete: () => {

            },
        }
        );
    });
}